import React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'danger';

interface DialogButtonProps {
  variant: ButtonVariant;
  onClick: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
  children: React.ReactNode;
  className?: string;
}

const buttonStyles: Record<ButtonVariant, React.CSSProperties> = {
  primary: {
    backgroundColor: '#171C27',
    color: '#FFFFFF',
    border: 'none',
  },
  secondary: {
    backgroundColor: '#FFFFFF',
    color: '#24AEA8',
    border: '1px solid #24AEA8',
  },
  danger: {
    backgroundColor: '#C42B1C',
    color: '#FFFFFF',
    border: 'none',
  },
};

const hoverColors: Record<ButtonVariant, string> = {
  primary: '#0d1118',
  secondary: '#f0fafa',
  danger: '#a82517',
};

export const DialogButton: React.FC<DialogButtonProps> = ({
  variant,
  onClick,
  disabled = false,
  fullWidth = false,
  children,
  className,
}) => {
  const style = buttonStyles[variant];
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <button
      className={className}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        ...style,
        flex: fullWidth ? 1 : undefined,
        height: '48px',
        borderRadius: '6px',
        padding: '12px 24px',
        textAlign: 'center',
        fontFamily: 'Interstate',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: variant === 'secondary' ? 700 : 600,
        lineHeight: '20px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        backgroundColor: isHovered && !disabled ? hoverColors[variant] : style.backgroundColor,
        transition: 'background-color 0.2s',
      }}
    >
      {children}
    </button>
  );
};
